// 服务前缀 admin or tenantadmin
export const API_CONTEXT = 'admin';
//测试环境
// export const API_CONTEXT = 'api-test';